import React, { Fragment } from 'react';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Geosuggest from '@ubilabs/react-geosuggest';
import DatePicker from 'react-datepicker';
import Select from 'react-select';
import { useDispatch } from 'react-redux';
import Question from '../Question';
import MultiSelectInput from '../MultiSelectInput';
import TextAreaInput from '../TextAreaInput';
import RadioInputGroup from '../RadioInputGroup';
import RateInput from '../RateInput';
import ErrorMessageField from '../ErrorMessageField';
import DocumentUpload from '../../DocumentUpload';
import PastRolesQuestion from '../PastRolesQuestion';
import ListForm from '../ListForm';
import GroupParentForm from '../GroupParentForm';
import DropdownIndicator from '../DropdownIndicator';
import ProficiencyTagRanking from '../ProficiencyTagRanking';
import dropdownStyleUtils from '../../../dropdownStyleUtils';
import { getRequest } from '../../../requestUtils';
import allActions from '../../../actions';
import { analyticsTrack } from '../../../analyticsUtils';
import '../Question/Question.scss';

const { profileSuggestions } = allActions;

const renderFileUpload = (
  text,
  subText,
  resumeUrl,
  resume,
  key,
  csrfToken,
  forceSmallQuestionTitle,
  style,
  onboardingQuestionnaire,
  handleMenuUpdate,
  handleNewResume,
  handleResumeUpload,
  userId,
) => (
  <Question
    title={text}
    titleStyleClass="mb-8"
    subtext={subText}
    isBig={forceSmallQuestionTitle !== true}
    questionKey={key}
    location={onboardingQuestionnaire ? 'onboarding' : 'profile-edit'}
  >
    <DocumentUpload
      location={onboardingQuestionnaire ? 'Onboarding Flow' : 'Consultant Profile'}
      prompt="Upload Resume"
      viewDocumentUrl={resume && `/resumes/${resume.resource_id}`}
      uploadDocumentUrl={resumeUrl}
      csrfToken={csrfToken}
      documentType="parsedResume"
      userId={userId}
      document={resume}
      handleMenuUpdate={handleMenuUpdate}
      handleNewResume={handleNewResume}
      buttonStyle="button"
      handleResumeUpload={handleResumeUpload}
    />
  </Question>
);

const renderTextArea = (
  text,
  subText,
  parent,
  answer,
  key,
  handleChange,
  forceSmallQuestionTitle,
  onboardingQuestionnaire,
) => (
  <Question
    title={text}
    titleStyleClass="mb-8"
    isBig={forceSmallQuestionTitle !== true && parent === null}
    subtext={subText}
    location={onboardingQuestionnaire ? 'onboarding' : 'profile-edit'}
  >
    <TextAreaInput
      className="form-control fs-hide"
      placeholder={key === 'bio' ? 'Type your bio here...' : 'Type here...'}
      rows={5}
      value={answer !== null ? answer : ''}
      required={false}
      onAnswerChange={(v) => handleChange(v, key)}
      textAreaPrompt=""
    />
  </Question>
);

const styleInputGroup = {
  wrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    paddingRight: '64px',

    flex: 'none',
    order: 2,
    alignSelf: 'stretch',
    flexGrow: 0,
    zIndex: 0,
  },
  input: {
    boxSizing: 'border-box',

    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0px 8px 0px 16px',
    gap: '8px',

    height: '40px',

    background: '#FFFFFF',

    border: '1px solid #242424',
    borderRadius: '2px 0px 0px 2px',

    flex: 'none',
    order: 1,
    alignSelf: 'stretch',
    flexGrow: 0,
  },
  button: {
    boxSizing: 'border-box',

    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0px 8px',

    height: '40px',

    borderRadius: '0px 4px 4px 0px',
    border: '1px solid #00A88C',

    flex: 'none',
    order: 1,
    flexGrow: 0,
  },
};
const renderTextInputGroupSuffix = (
  text,
  subText,
  parent,
  answer,
  key,
  addon,
  addonUrl,
  handleChange,
  forceSmallQuestionTitle,
  csrfToken,
  onboardingQuestionnaire,
  userId,
) => {
  const dispatch = useDispatch();

  const onVerify = () => {
    getRequest(addonUrl, {}, csrfToken).then(
      (response) => {
        if (response.data) {
          dispatch(profileSuggestions.linkedinProfileParsed(response.data));
        }
      },
    );
  };

  const onFocus = () => {
    analyticsTrack('Indication linkedin', {
      onboardingQuestionnaire,
      userId,
    });
  };

  return (
    <Question
      title={text}
      titleStyleClass="mb-8"
      subtext={subText}
      isBig={forceSmallQuestionTitle !== true && parent === null}
      questionKey={key}
      location={onboardingQuestionnaire ? 'onboarding' : 'profile-edit'}
    >
      <div style={styleInputGroup.wrapper}>
        <input
          type="text"
          id={`${key}-question-text-input`}
          style={styleInputGroup.input}
          placeholder={key === 'linkedin' ? 'Paste LinkedIn URL' : 'Write here...'}
          value={answer !== null ? answer : ''}
          required={false}
          onChange={(v) => handleChange(v.target.value, key)}
          onFocus={onFocus}
        />
        { addon
          && (
          <button
            disabled={key === 'linkedin' && (answer === null || !answer.match(/linkedin\.com/i))}
            onClick={() => onVerify()}
            className="btn btn-secondary-dark"
            style={styleInputGroup.button}
          >
            { addon }
          </button>
          )}
      </div>
    </Question>
  );
};

const renderTextInput = (
  text,
  subText,
  parent,
  answer,
  key,
  handleChange,
  forceSmallQuestionTitle,
  onboardingQuestionnaire,
) => (
  <Question
    title={text}
    titleStyleClass="mb-8"
    subtext={subText}
    isBig={forceSmallQuestionTitle !== true && parent === null}
    questionKey={key}
    location={onboardingQuestionnaire ? 'onboarding' : 'profile-edit'}
  >
    <input
      type="text"
      id={`${key}-question-text-input`}
      className="form-control fs-hide mt-3"
      placeholder={key === 'linkedin' ? 'Paste your LinkedIn URL here' : 'Write here...'}
      value={answer !== null ? answer : ''}
      required={false}
      onChange={(v) => handleChange(v.target.value, key)}
    />
  </Question>
);

const renderList = (
  questionText,
  subtext,
  answer,
  questionKey,
  handleChange,
  limit,
  closeModal,
  style,
) => (
  <Question
    title={questionText}
    titleStyleClass="mb-8"
    subtext={subtext}
    isBig
  >
    <ListForm
      answer={answer || ['']}
      questionKey={questionKey}
      handleChange={handleChange}
      limit={limit}
      closeModal={closeModal}
      style={style}
    />
  </Question>
);

const renderNumericRangeTextInput = (
  text,
  subText,
  parent,
  answer,
  key,
  handleChange,
  forceSmallQuestionTitle,
  onboardingQuestionnaire,
  userId,
  updateParentError,
) => {
  const mapping = {
    hourly_rate_range: 'Indicating Rate Value',
    availability: 'Indicating hours per week Value',
  };

  const validRange = () => {
    if (answer !== null) {
      const min = parseInt(answer.low, 10);
      const max = parseInt(answer.high, 10);
      return min >= 0 && max >= 0 ? min <= max : false;
    }
    return true;
  };

  const validRate = () => {
    if (answer) {
      if (answer.low && answer.low.toString().includes('.')) { return false; }
      if (answer.high && answer.high.toString().includes('.')) { return false; }
    }
    return true;
  };

  const onChange = (v, position, minOrMax) => {
    handleChange(v, key, position);
    if (key === 'hourly_rate_range' || key === 'availability') {
      updateParentError(!validRate() || !validRange());
    }
    analyticsTrack(`${mapping[key]} - ${text} - ${minOrMax}`, {
      location: onboardingQuestionnaire ? 'Onboarding Flow' : 'Not Onboarding Flow',
      questionKey: key,
      userId,
    });
  };

  let errorMessage = null;

  if (!validRate()) {
    errorMessage = 'Please enter whole numbers only.';
  } else if (!validRange()) {
    errorMessage = 'The maximum value must be larger than the minimum value.';
  }

  return (
    <Question
      title={key === 'availability' ? '' : text}
      titleStyleClass="mb-8"
      subtext={subText}
      isBig={forceSmallQuestionTitle !== true && parent === null}
      location={onboardingQuestionnaire ? 'onboarding' : 'profile-edit'}
    >
      <div className={`g-row ${onboardingQuestionnaire ? `onboarding-${key}` : ''}`}>
        <RateInput
          id="low-end-hourly-range-input"
          value={answer !== null ? answer.low : ''}
          onAnswerChange={(v) => onChange(v, 'low', 'Minimum')}
          placeholder="Low End"
          onboardingQuestionnaire={onboardingQuestionnaire}
          minOrMax="Minimum"
          inputClass={`mt-2 ${key}`}
          allowDecimals={false}
        >
          { key === 'hourly_rate_range' && <span className={`input-group-addon ${onboardingQuestionnaire ? 'addon-bg-color' : ''}`}>$</span> }
        </RateInput>
        <RateInput
          id="high-end-hourly-range-input"
          value={answer !== null ? answer.high : ''}
          onAnswerChange={(v) => onChange(v, 'high', 'Maximum')}
          placeholder="High End"
          onboardingQuestionnaire={onboardingQuestionnaire}
          minOrMax="Maximum"
          inputClass={`mt-2 ${key}`}
          allowDecimals={false}
        >
          { key === 'hourly_rate_range' && <span className={`input-group-addon ${onboardingQuestionnaire ? 'addon-bg-color' : ''}`}>$</span> }
        </RateInput>
      </div>
      <ErrorMessageField
        errorMessage={errorMessage}
        showMessage={errorMessage}
      />
    </Question>
  );
};

const renderDateRangeDateInput = (
  text,
  subText,
  parent,
  answer,
  key,
  handleChange,
  forceSmallQuestionTitle,
  onboardingQuestionnaire,
) => {
  const toDate = (date) => window.moment(date).utc(true).toDate();

  const invalidDate = () => {
    if (answer !== null) {
      if (toDate(answer.start_date) === null) return false;
      if (toDate(answer.end_date) !== null
        && toDate(answer.end_date) > toDate(answer.start_date)) {
        return false;
      }
    }
    return true;
  };

  return (
    <Question
      title={key === 'available_when' ? '' : text}
      titleStyleClass="mb-8"
      subtext={subText}
      isBig={forceSmallQuestionTitle !== true && parent === null}
      location={onboardingQuestionnaire ? 'onboarding' : 'profile-edit'}
    >
      <div className={`g-row ${onboardingQuestionnaire ? `onboarding-${key}` : ''}`}>
        <div className={`g-row--always calendar-${key}`}>
          <span>Starting</span>
          <DatePicker
            selected={answer && answer.start_date ? toDate(answer.start_date) : null}
            onChange={(v) => handleChange(v, key, 'start_date')}
            allowSameDay
            className={`form-control calendar-${key} ${onboardingQuestionnaire ? 'onboarding-input-edges' : ''}`}
            value={answer && answer.start_date
              ? toDate(answer.start_date) : window.moment().toDate()}
            dateFormat="MM/dd/yyyy"
            placeholderText="Click to select a date"
          />
        </div>
        <div className={`g-row--always calendar-${key}`}>
          <span>Ending</span>
          <DatePicker
            selected={answer && answer.end_date ? toDate(answer.end_date) : null}
            onChange={(v) => handleChange(v, key, 'end_date')}
            allowSameDay
            className={`form-control calendar-${key} ${onboardingQuestionnaire ? 'onboarding-input-edges' : ''}`}
            value={answer && answer.end_date
              ? toDate(answer.end_date) : window.moment().toDate()}
            dateFormat="MM/dd/yyyy"
            placeholderText="Click to select a date"
          />
        </div>
      </div>
      <ErrorMessageField
        errorMessage="Starting date is required and must be before ending date."
        showMessage={invalidDate()}
      />
    </Question>
  );
};

const renderNumberInput = (
  text,
  subText,
  parent,
  answer,
  key,
  handleChange,
  forceSmallQuestionTitle,
  onboardingQuestionnaire,
) => (
  <Question
    title={text}
    titleStyleClass="mb-8"
    subtext={subText}
    isBig={forceSmallQuestionTitle !== true && parent === null}
    questionKey={key}
    location={onboardingQuestionnaire ? 'onboarding' : 'profile-edit'}
  >
    <div className={`g-row--always ${onboardingQuestionnaire ? key : ''}`}>
      <input
        type="number"
        id={`${key}-number-input`}
        className={`form-control number-input ${onboardingQuestionnaire ? 'onboarding-input-edges' : ''}`}
        value={answer !== null ? answer : ''}
        onChange={(v) => handleChange(v.target.value, key)}
      />
      {
        !onboardingQuestionnaire
          && (
          <span className="body-text-2 ms-3 mt-2">
            {key === 'years_of_experience' ? 'years' : 'hours per week'}
          </span>
          )
      }
    </div>
  </Question>
);

const renderGeosuggest = (
  text,
  subText,
  parent,
  answer,
  key,
  handleChange,
  forceSmallQuestionTitle,
  onboardingQuestionnaire,
  userId,
) => {
  const onChange = (obj) => {
    analyticsTrack(`Indicating [${text}]`, {
      location: onboardingQuestionnaire ? 'Onboarding Flow' : 'Not Onboarding Flow',
      userId,
    });

    handleChange(obj.label, key);
  };

  return (
    <Question
      title={text}
      titleStyleClass="mb-8"
      subtext={subText}
      isBig={forceSmallQuestionTitle !== true && parent === null}
      questionKey={key}
      location={onboardingQuestionnaire ? 'onboarding' : 'profile-edit'}
    >
      <div className="input-field">
        <Geosuggest
          initialValue={answer !== null ? answer : ''}
          suggestItemClassName="geosuggest-font"
          inputClassName="input-base"
          placeholder="Type your current location"
          onChange={(v) => handleChange(v, key)}
          onSuggestSelect={(obj) => obj && onChange(obj)}
          autoActivateFirstSuggest
        />
      </div>
    </Question>
  );
};

const renderGroupedRadio = (
  text,
  subText,
  parent,
  options,
  values,
  key,
  handleChange,
  forceSmallQuestionTitle,
  onboardingQuestionnaire,
  userId,
) => {
  const onChange = (option) => {
    analyticsTrack(`Indicating ${text}`, {
      location: onboardingQuestionnaire ? 'Onboarding Flow' : 'Not Onboarding Flow',
      userId,
      questionKey: key,
      value: option,
    });
    handleChange(option, key);
  };

  return (
    <Question
      title={text}
      titleStyleClass="mb-8"
      subtext={subText}
      isBig={forceSmallQuestionTitle !== true && parent === null}
      location={onboardingQuestionnaire ? 'onboarding' : 'profile-edit'}
    >
      <RadioInputGroup
        options={options}
        handleInputChange={(option) => onChange(option)}
        selected={values && values.value}
        name={key}
      />
    </Question>
  );
};

const renderBooleanCheckbox = (
  text,
  subText,
  parent,
  isParent,
  value,
  key,
  label,
  handleChange,
  forceSmallQuestionTitle,
  onboardingQuestionnaire,
  userId,
) => {
  const onChange = () => {
    analyticsTrack(`Indicating ${text}`, {
      location: onboardingQuestionnaire ? 'Onboarding Flow' : 'Not Onboarding Flow',
      userId,
      questionKey: key,
      action: value === 'true' ? 'Indicating' : label,
    });
    handleChange(`${!(value === 'true')}`, key);
  };
  return (
    <Question
      title={text}
      titleStyleClass="mb-8"
      subtext={subText}
      isBig={forceSmallQuestionTitle !== true && parent === null}
      isParent={isParent}
      location={onboardingQuestionnaire ? 'onboarding' : 'profile-edit'}
    >
      <label className="custom-checkbox-container body-text-2" htmlFor="boolean">
        <input
          type="checkbox"
          id="boolean"
          defaultChecked={value === 'true'}
          onClick={() => onChange()}
        />
        <span className="checkmark" />
        <span className="label">{label}</span>
      </label>
    </Question>
  );
};

const renderSingleSelect = (
  title,
  subtext,
  answer,
  key,
  answerOptions,
  handleChange,
) => (
  <Question
    title={title}
    subtext={subtext}
    titleStyleClass="mb-12"
    isBig
  >
    <div className="single-dropdown">
      <Select
        components={{ DropdownIndicator, IndicatorSeparator: () => null }}
        styles={{ ...dropdownStyleUtils }}
        placeholder="Select hours"
        options={answerOptions}
        value={answer && answerOptions.find((o) => o.value === answer.value)}
        onChange={(v) => handleChange(v, key)}
        classNamePrefix="clora-select"
      />
    </div>
  </Question>
);

const renderMultiSelect = (
  text,
  subtext,
  parent,
  options,
  values,
  key,
  handleChange,
  asyncUrl,
  disabled,
  hasOther,
  hasFilter,
  style,
  limit,
  onlyCustom,
  forceSmallQuestionTitle,
  suggestedAnswers,
  onboardingQuestionnaire,
  userId,
) => (
  <Question
    title={text}
    titleStyleClass="mb-8"
    isBig={forceSmallQuestionTitle !== true && parent === null}
    questionKey={key}
    location={onboardingQuestionnaire ? 'onboarding' : 'profile-edit'}
  >
    <MultiSelectInput
      subtext={subtext}
      options={options}
      values={values !== null ? values : []}
      handleSelectChange={(option) => handleChange(option, key)}
      asyncUrl={asyncUrl}
      disabled={disabled}
      hasOther={hasOther}
      hasFilter={hasFilter}
      style={style}
      limit={limit}
      onlyCustom={onlyCustom}
      suggestedAnswers={suggestedAnswers}
      text={text}
      onboardingQuestionnaire={onboardingQuestionnaire}
      questionKey={key}
      userId={userId}
      closeOnSelect={onboardingQuestionnaire && key === 'roles'}
    />
  </Question>
);

const renderDateInput = (
  text,
  subtext,
  parent,
  answer,
  key,
  handleChange,
  forceSmallQuestionTitle,
  onboardingQuestionnaire,
) => (
  <Question
    title={text}
    className={key}
    isBig={forceSmallQuestionTitle !== true && parent === null}
    location={onboardingQuestionnaire ? 'onboarding' : 'profile-edit'}
    questionKey={key}
  >
    <label className="g-row--always" htmlFor={`calendar-${key}`}>
      <DatePicker
        selected={answer ? window.moment(answer).toDate() : null}
        onChange={(v) => handleChange(v, key)}
        allowSameDay
        className={`form-control calendar-${key} ${onboardingQuestionnaire ? 'onboarding-input-edges' : ''}`}
        value={answer ? window.moment(answer).toDate() : window.moment().toDate()}
        dateFormat="MM/dd/yyyy"
        placeholderText="Click to select a date"
      />
    </label>
  </Question>
);

const renderPastRoles = (
  title,
  subtext,
  answer,
  key,
  handleChange,
  closeModal,
  forceSmallQuestionTitle,
  saveOnChange,
  suggestedAnswers,
  onboardingQuestionnaire,
  profileQuestionnaire,
  objectId,
  isReadingMore,
  handlePastRolesAfterUpdate,
) => (
  <Question
    title={title}
    subtext={subtext}
    isBig={forceSmallQuestionTitle !== true}
    questionKey={key}
    location={onboardingQuestionnaire ? 'onboarding' : 'profile-edit'}
  >
    <PastRolesQuestion
      questionKey={key}
      newPastRoles={suggestedAnswers && suggestedAnswers.length > 0 && answer.length === 0
        ? suggestedAnswers : answer}
      handleChange={handleChange}
      closeModal={closeModal}
      saveOnChange={saveOnChange}
      onboardingQuestionnaire={onboardingQuestionnaire}
      profileQuestionnaire={profileQuestionnaire}
      objectId={objectId}
      isReadingMore={isReadingMore}
      handlePastRolesAfterUpdate={handlePastRolesAfterUpdate}
    />
  </Question>
);

const renderProficiencies = (
  title,
  subtext,
  answer,
  key,
  answerOptions,
  handleChange,
) => (
  <Question
    title={title}
    subtext={subtext}
    titleStyleClass="mb-12"
    isBig
  >
    {answer.map((ans, idx) => (
      <Row className="proficiency-input-row mb-8" key={`${ans.value}-proficiency`} id={`${ans.value}-proficiency`}>
        <Col xs={8}>
          {ans.ranking
            && (
            <span className="mr-6">
              {ans.ranking}
              .
            </span>
            )}
          <span className="badge green-light experience-tag">{ans.label}</span>

        </Col>
        <Col xs={4} className="proficiency-dropdowns">
          <Select
            components={{ DropdownIndicator, IndicatorSeparator: () => null }}
            styles={{ ...dropdownStyleUtils }}
            placeholder="Select years"
            options={answerOptions}
            value={answerOptions.find((o) => o.value === ans.proficiency)}
            onChange={(v) => handleChange(v.value, key, idx)}
            classNamePrefix="clora-select"
          />
        </Col>
      </Row>
    ))}
  </Question>
);

const renderProficiencyRankings = (
  title,
  subtext,
  answer,
  rankedTagsCount,
  handleChange,
  questionKey,
) => (
  <Question
    title={title}
    subtext={subtext}
    titleStyleClass="mb-12"
    isBig
  >
    <ProficiencyTagRanking
      answer={answer}
      rankedTagsCount={rankedTagsCount}
      handleChange={handleChange}
      questionKey={questionKey}
    />
  </Question>
);

const renderGroupParent = (
  questionText,
  subtext,
  answer,
  questionKey,
  handleChange,
  limit,
  closeModal,
  childrenQuestions,
  parentId,
  disabled,
  handleMenuUpdate,
  onboardingQuestionnaire,
  userId,
) => (
  <Question
    title={parentId ? null : questionText}
    titleStyleClass="mb-8"
    subtext={subtext}
    disabled={disabled}
    isBig
    location={onboardingQuestionnaire ? 'onboarding' : 'profile-edit'}
    questionKey={questionKey}
  >
    <GroupParentForm
      answers={answer}
      questionKey={questionKey}
      handleChange={handleChange}
      limit={limit}
      closeModal={closeModal}
      childrenQuestions={childrenQuestions}
      disabled={disabled}
      onboardingQuestionnaire={onboardingQuestionnaire}
      handleMenuUpdate={handleMenuUpdate}
      userId={userId}
    />
  </Question>
);

const renderQuestion = (
  userId,
  question,
  handleChange,
  handleOtherTextChange,
  csrfToken,
  disabled,
  closeModal,
  forceSmallQuestionTitle,
  suggestedAnswers,
  saveOnChange,
  questionnaireName,
  handleMenuUpdate,
  handleNewResume,
  updateParentError,
  objectId,
  isReadingMore,
  handleResumeUpload,
  handlePastRolesAfterUpdate,
) => {
  const onboardingQuestionnaire = questionnaireName === 'Consultant Onboarding';
  const profileQuestionnaire = questionnaireName === 'Consultant Profile';
  if (disabled && (question.trigger_type === 'hide' || question.trigger_type === 'show')) return null;
  switch (question.question_type) {
    case 'only_custom_tags':
    case 'select_many':
      return renderMultiSelect(
        question.question_text,
        question.subtext,
        question.parent_id,
        question.answer_options,
        question.answer,
        question.question_key,
        handleChange,
        question.async_url,
        disabled,
        question.has_other,
        question.has_filter,
        question.style,
        question.limit,
        question.question_type === 'only_custom_tags',
        forceSmallQuestionTitle,
        (suggestedAnswers && suggestedAnswers[question.question_key]),
        onboardingQuestionnaire,
        userId,
      );
    case 'select_one':
      if (question.style === 'radio_oneline') {
        return renderGroupedRadio(
          question.question_text,
          question.subtext,
          question.parent_id,
          question.answer_options,
          question.answer,
          question.question_key,
          handleChange,
          forceSmallQuestionTitle,
          onboardingQuestionnaire,
          userId,
        );
      }
      if (question.style === 'single_select') {
        return renderSingleSelect(
          question.question_text,
          question.subtext,
          question.answer,
          question.question_key,
          question.answer_options,
          handleChange,
        );
      }
      break;
    case 'numeric_range':
      if (question.style === 'text_input') {
        return renderNumericRangeTextInput(
          question.question_text,
          question.subtext,
          question.parent_id,
          question.answer,
          question.question_key,
          handleChange,
          forceSmallQuestionTitle,
          onboardingQuestionnaire,
          userId,
          updateParentError,
        );
      }
      break;
    case 'date_range':
      if (question.style === 'datepicker') {
        return renderDateRangeDateInput(
          question.question_text,
          question.subtext,
          question.parent_id,
          question.answer,
          question.question_key,
          handleChange,
          forceSmallQuestionTitle,
          onboardingQuestionnaire,
        );
      }
      break;
    case 'freetext':
    case 'location':
      if (question.style === 'text_input') {
        return renderTextInput(
          question.question_text,
          question.subtext,
          question.parent_id,
          question.answer,
          question.question_key,
          handleChange,
          forceSmallQuestionTitle,
          csrfToken,
          onboardingQuestionnaire,
        );
      } if (question.style === 'geosuggest') {
        return renderGeosuggest(
          question.question_text,
          question.subtext,
          question.parent_id,
          question.answer,
          question.question_key,
          handleChange,
          forceSmallQuestionTitle,
          onboardingQuestionnaire,
          userId,
        );
      } if (question.style === 'text_area') {
        return renderTextArea(
          question.question_text,
          question.subtext,
          question.parent_id,
          question.answer,
          question.question_key.replace(/_/g, ' '),
          handleChange,
          forceSmallQuestionTitle,
          onboardingQuestionnaire,
        );
      } if (question.style === 'text_input_group_suffix') {
        return renderTextInputGroupSuffix(
          question.question_text,
          question.subtext,
          question.parent_id,
          question.answer,
          question.question_key,
          question.addon,
          question.addon_url,
          handleChange,
          forceSmallQuestionTitle,
          csrfToken,
          onboardingQuestionnaire,
          userId,
        );
      }
      break;
    case 'file':
      return renderFileUpload(
        question.question_text,
        question.subtext,
        question.resume_url,
        question.answer,
        question.question_key,
        csrfToken,
        forceSmallQuestionTitle,
        question.style,
        onboardingQuestionnaire,
        handleMenuUpdate,
        handleNewResume,
        handleResumeUpload,
      );
    case 'number':
      if (question.style === 'number_input') {
        return renderNumberInput(
          question.question_text,
          question.subtext,
          question.parent_id,
          question.answer,
          question.question_key,
          handleChange,
          forceSmallQuestionTitle,
          onboardingQuestionnaire,
        );
      }
      break;
    case 'date':
      return renderDateInput(
        question.question_text,
        question.subtext,
        question.parent_id,
        question.answer,
        question.question_key,
        handleChange,
        forceSmallQuestionTitle,
        onboardingQuestionnaire,
      );
    case 'past_roles':
      return renderPastRoles(
        question.question_text,
        question.subtext,
        question.answer,
        question.question_key,
        handleChange,
        closeModal,
        forceSmallQuestionTitle,
        saveOnChange,
        (suggestedAnswers && suggestedAnswers[question.question_key]),
        onboardingQuestionnaire,
        profileQuestionnaire,
        objectId,
        isReadingMore,
        handlePastRolesAfterUpdate,
      );
    case 'boolean':
      return renderBooleanCheckbox(
        question.question_text,
        question.subtext,
        question.parent_id,
        question.parent,
        question.answer,
        question.question_key,
        question.answer_options[0].label,
        handleChange,
        forceSmallQuestionTitle,
        onboardingQuestionnaire,
        userId,
      );
    case 'list':
      return renderList(
        question.question_text,
        question.subtext,
        question.answer,
        question.question_key,
        handleChange,
        question.limit,
        closeModal,
        question.style,
        onboardingQuestionnaire,
      );
    case 'group_parent':
      return renderGroupParent(
        question.question_text,
        question.subtext,
        question.answer,
        question.question_key,
        handleChange,
        question.limit,
        closeModal,
        question.children_questions,
        question.parent_id,
        disabled,
        handleMenuUpdate,
        onboardingQuestionnaire,
        userId,
      );
    case 'proficiency':
      return renderProficiencies(
        question.question_text,
        question.subtext,
        question.answer,
        question.question_key,
        question.answer_options,
        handleChange,
        question.limit,
        closeModal,
        question.style,
      );
    case 'proficiency_ranking':
      return renderProficiencyRankings(
        question.question_text,
        question.subtext,
        question.answer,
        question.answer_options,
        handleChange,
        question.question_key,
      );
    default:
      return null;
  }

  return null;
};

function QuestionRenderer({
  question,
  handleChange,
  handleOtherTextChange,
  csrfToken,
  disabled,
  closeModal,
  forceSmallQuestionTitle,
  suggestedAnswers,
  saveOnChange,
  questionnaireName,
  handleMenuUpdate,
  userId,
  handleNewResume,
  updateParentError,
  objectId,
  isReadingMore,
  handleResumeUpload,
  handlePastRolesAfterUpdate,
}) {
  return (
    <Fragment>
      {renderQuestion(
        userId,
        question,
        handleChange,
        handleOtherTextChange,
        csrfToken,
        disabled,
        closeModal,
        forceSmallQuestionTitle,
        suggestedAnswers,
        saveOnChange,
        questionnaireName,
        handleMenuUpdate,
        handleNewResume,
        updateParentError,
        objectId,
        isReadingMore,
        handleResumeUpload,
        handlePastRolesAfterUpdate,
      )}
    </Fragment>
  );
}

QuestionRenderer.propTypes = {
  question: PropTypes.shape({}).isRequired,
  handleChange: PropTypes.func.isRequired,
  handleOtherTextChange: PropTypes.func.isRequired,
  csrfToken: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  closeModal: PropTypes.func,
  forceSmallQuestionTitle: PropTypes.bool,
  suggestedAnswers: PropTypes.shape([]),
  saveOnChange: PropTypes.bool,
  handleMenuUpdate: PropTypes.func,
  questionnaireName: PropTypes.string,
  userId: PropTypes.number,
  handleNewResume: PropTypes.func,
  handleResumeUpload: PropTypes.func,
  updateParentError: PropTypes.func,
  objectId: PropTypes.number,
  isReadingMore: PropTypes.bool,
  handlePastRolesAfterUpdate: PropTypes.func,
};

QuestionRenderer.defaultProps = {
  closeModal: () => {},
  forceSmallQuestionTitle: false,
  saveOnChange: false,
  questionnaireName: 'Consultant Onboarding',
  userId: null,
  objectId: null,
  isReadingMore: false,
  handleNewResume: () => {},
  handleResumeUpload: () => {},
  updateParentError: () => {},
  handlePastRolesAfterUpdate: () => {},
};

export default QuestionRenderer;
